import * as React from 'react';
const SvgChartBarHorizontal = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      d="M11 14.527c0-.11-.02-.19-.05-.25a.5.5 0 0 0-.22-.22.5.5 0 0 0-.18-.05H6.81c-.28 0-.42 0-.53.05a.52.52 0 0 0-.22.22c-.03.06-.04.12-.05.22v.99c0 .11.02.191.05.251.05.09.12.17.22.22.05.03.11.04.18.05h3.7399999999999998c.28 0 .42 0 .53-.05a.52.52 0 0 0 .22-.22c.03-.06.04-.12.05-.22v-.99M13 10.526c0-.11-.02-.19-.05-.25a.52.52 0 0 0-.22-.22.5.5 0 0 0-.18-.05H6.8c-.28 0-.42 0-.53.05a.52.52 0 0 0-.22.22c-.03.06-.04.12-.05.22v.99c0 .11.02.19.05.25.05.09.12.17.22.22.05.03.11.04.18.05h5.74c.28 0 .42 0 .53-.05.09-.05.17-.12.22-.22.03-.06.04-.12.05-.22v-.99z"
    />
    <path
      fill="currentColor"
      d="M22 18.53c0-.11-.02-.19-.05-.25a.5.5 0 0 0-.22-.22.5.5 0 0 0-.18-.05H6.8c-1 0-2.04 0-2.25-.111-.19-.1-.34-.25-.44-.44-.11-.21-.11-1.25-.11-2.251V6.804c0-.28 0-.42-.05-.53a.5.5 0 0 0-.22-.22.6.6 0 0 0-.22-.05h-.99a.55.55 0 0 0-.25.05c-.09.05-.17.12-.22.22-.03.05-.04.11-.05.18v8.744c0 1.68 0 2.52.33 3.161.29.56.75 1.02 1.31 1.31C4.28 20 5.12 20 6.8 20h14.4c.28 0 .42 0 .53-.05a.52.52 0 0 0 .22-.22c.03-.06.04-.12.05-.22v-.99z"
    />
    <path
      fill="currentColor"
      d="m17.54 9.865 2.17-2.16c.38-.38.38-1.001 0-1.391l-2.17-2.171a.5.5 0 0 0-.7 0l-.7.69a.49.49 0 0 0 0 .69l.47.47H6.8c-.28 0-.42 0-.53.05-.09.05-.17.12-.22.22-.03.06-.04.12-.05.22v.991c0 .11.02.19.05.25.05.09.12.17.22.22.05.03.11.04.18.05h10.16l-.47.47a.49.49 0 0 0 0 .69l.7.691c.19.19.5.19.7 0z"
    />
  </svg>
);
export default SvgChartBarHorizontal;
